import React from 'react';

interface MoneyInputProps {
  id?: string;
  label: string;
  value: number;
  currencySymbol?: string;
  currencyCode?: string;
  onChange: (val: number) => void;
  hint?: string;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

export const MoneyInput: React.FC<MoneyInputProps> = ({
  id,
  label,
  value,
  currencySymbol = '$',
  currencyCode = 'USD',
  onChange,
  hint,
  min = 0,
  max = 100000000,
  step = 10,
  className = '',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawVal = e.target.value.replace(/[^0-9.]/g, '');
    const num = parseFloat(rawVal);
    if (!isNaN(num)) {
      onChange(Math.min(max, Math.max(min, num)));
    } else if (rawVal === '') {
      onChange(0);
    }
  };

  return (
    <div className={`space-y-1.5 ${className}`}>
      <div className="flex items-center justify-between">
        <label htmlFor={id} className="text-xs font-semibold text-[#1A1A1A] block">
          {label}
        </label>
        {currencyCode && (
          <span className="text-[10px] font-mono font-bold text-[#6B7280] bg-[#F3F4F6] px-1.5 py-0.5 rounded border border-[#E5E7EB]">
            {currencyCode}
          </span>
        )}
      </div>

      <div className="relative flex items-center">
        <span className="absolute left-3.5 text-sm font-semibold text-[#6B7280] select-none">
          {currencySymbol}
        </span>
        <input
          id={id}
          type="text"
          inputMode="decimal"
          value={value === 0 ? '' : value.toLocaleString('en-US')}
          placeholder="0.00"
          onChange={handleChange}
          className="w-full pl-8 pr-3.5 py-2.5 bg-white border border-[#E5E7EB] hover:border-[#D1D5DB] focus:border-[#1A1A1A] focus:ring-1 focus:ring-[#1A1A1A] rounded-xl text-sm font-bold text-[#1A1A1A] font-mono transition-all outline-none"
        />
      </div>

      {hint && (
        <p className="text-[11px] text-[#6B7280] leading-tight">{hint}</p>
      )}
    </div>
  );
};
